"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _LinkRaw = _interopRequireDefault(require("@commerce-ui/core2/LinkRaw"));
var _Box = _interopRequireDefault(require("@commerce-ui/core2/Box"));
var _Image = _interopRequireDefault(require("../Image"));
var _RouteContext = require("@deosite/lib/RouteContext");
var __jsx = _react["default"].createElement;
var defaultProps = {
  imageBorderRadius: "0px",
  titleAs: "p",
  infoOnly: false,
  font: "heading3",
  titleMargin: null,
  squareImage: false
};
var CardWithLabel = function CardWithLabel(props) {
  var image = props.image,
    name = props.name,
    params = props.params,
    href = props.href,
    _props$titleAs = props.titleAs,
    titleAs = _props$titleAs === void 0 ? defaultProps.titleAs : _props$titleAs,
    _props$imageBorderRad = props.imageBorderRadius,
    imageBorderRadius = _props$imageBorderRad === void 0 ? defaultProps.imageBorderRadius : _props$imageBorderRad,
    _props$infoOnly = props.infoOnly,
    infoOnly = _props$infoOnly === void 0 ? defaultProps.infoOnly : _props$infoOnly,
    _props$font = props.font,
    font = _props$font === void 0 ? defaultProps.font : _props$font,
    _props$titleMargin = props.titleMargin,
    titleMargin = _props$titleMargin === void 0 ? defaultProps.titleMargin : _props$titleMargin,
    _props$squareImage = props.squareImage,
    squareImage = _props$squareImage === void 0 ? defaultProps.squareImage : _props$squareImage;
  var _useRouteContext = (0, _RouteContext.useRouteContext)(),
    Link = _useRouteContext.Link;
  var content = __jsx(_Box["default"], null, __jsx(_Image["default"], {
    sx: {
      marginBottom: "s6",
      borderRadius: imageBorderRadius,
      mb: titleMargin !== null && titleMargin !== void 0 ? titleMargin : 0
    },
    image: image,
    sizes: "420px"
  }), __jsx(_Box["default"], {
    as: titleAs,
    sx: {
      textAlign: "left",
      font: font,
      color: "main"
    }
  }, name));
  return infoOnly ? __jsx(_Box["default"], null, content) : __jsx(Link, {
    route: href,
    params: {
      url: (params === null || params === void 0 ? void 0 : params.url.indexOf("/")) === 0 ? params.url.replace("/", "") : params.url
    }
  }, __jsx(_LinkRaw["default"], {
    title: name
  }, content));
};
var _default = CardWithLabel;
exports["default"] = _default;